import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "salesforce",
  "name": "Salesforce",
  "category": "integrations",
  "description": "Interact with Salesforce CRM records",
  "icon": "siSalesforce",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "1.5.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Salesforce",
    "color": "#00a1e0"
  },
  "credentials": [
    {
      "name": "salesforceOAuth2",
      "required": true,
      "displayName": "Salesforce OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "salesforce",
    "crm",
    "sales",
    "leads",
    "opportunities"
  ],
  "comingSoon": true
};

export default definition;
